import PatientService from '../../services/PatientService';
import MenuService from "../../services/MenuService";

const patientService = new PatientService();
const menuService = new MenuService();
const initialState = {
    patient: {
        id: null,
        sex: '',
        first_name: '',
        last_name: '',
        age: '',
        phone_number: '',
        email: '',
        street: '',
        building_number: '',
        apartment_number: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        current_weight: null,
        fair_weight: null,
    },
    patientsCount: 0,
    patientMenusCount: 0,
};

const state = Object.assign({}, initialState);

const getters = {
    patient: state => state.patient,
    patientsCount: state => state.patientsCount,
    patientMenusCount: state => state.patientMenusCount,
};

const actions = {
    async fetchPatient({commit}, patientId) {
        const {data} = await patientService.fetchPatient(patientId);
        const patient = data.data;

        commit('setPatient', patient);
    },
    async updatePatient({commit}, patient) {
        const {data} = await patientService.updatePatient(patient);
        const updatedPatient = data.data;

        commit('setPatient', updatedPatient);
    },
    async deletePatient({commit}, patientId) {
        await patientService.delete(patientId);

        commit('setPatient', Object.assign({}, initialState));
    },
    async savePatient({commit}, patient) {
        const {data} = await patientService.savePatient(patient);
        const savedPatient = data.data;

        commit('setPatient', savedPatient);
    },
    async fetchPatientsCount({commit}) {
        const {data} = await patientService.fetchPatientsCount();

        commit('setPatientsCount', data.patientsCount);
    },
    async fetchPatientMenusCount({commit}, patientId) {
        const {data} = await menuService.fetchMenusCount(patientId);

        commit('setPatientMenusCount', data.menusCount);
    }
};

const mutations = {
    setPatient: (state, patient) => (state.patient = patient),
    setPatientsCount: (state, patientsCount) => (state.patientsCount = patientsCount),
    setPatientMenusCount: (state, patientMenusCount) => (state.patientMenusCount = patientMenusCount),
};

export default {
    state,
    getters,
    actions,
    mutations
};
